$(document).ready(function(){

  var globalRentalTerm = function (){

    var $termSelect = $('#rental-term-value');
    var termFlag = false;
    var termLength;


    $('.term-selection-container').on('click', function(e){
      $(this).addClass('active')
      $('body').addClass('scroll-lock')
    })
    $('.term-selection-container').on('mouseleave', function(e){
      $(this).removeClass('active')
      $('body').removeClass('scroll-lock')
      //     $(".term-selection-container").animate({ scrollTop: 0 }, "fast")

    })


    $('.rental-term').on('click', function(e){
      e.stopPropagation()
      $('.term-selection-container').removeClass('active')
      var value = $(this).val()
      //     $(this).parents().find('.term-seletion-container').toggleClass('active')
      $('#rental-term-value').val(value).text(value)
      $this = $(this)
      termLength = parseInt($this.val())
      termFlag = true
      sessionStorage.setItem("rentalTerm", termLength)
      applyGlobalRentalTerm(termLength)
      $('body').removeClass('scroll-lock')
      //     $(".term-selection-container").animate({ scrollTop: 0 }, "fast")
    })


    termLength = sessionStorage.getItem('rentalTerm')
    if (termLength != undefined || termLength != null) {
      $termSelect.val( termLength )
      termFlag = true
      $('#rental-term-value').val(termLength).text(termLength)
      applyGlobalRentalTerm(termLength)
    }



    function applyGlobalRentalTerm (length){
      if (typeof length == "string") {
        length = parseInt(length)
      }
      //this is for product pages
      if (window.location.href.indexOf("products") > -1  && window.location.href != "https://getmobley.com/collections/all-products-1" ) {
        waitForEl('#productSelect-option-0', function(){
          var $productSelect = $(`#productSelect-option-0 option[value="${length} months"]`)

          $(`#productSelect-option-0`).val(length + " months").trigger('change').trigger('click')
          $('#productSelect-option-0').on('change', function(){
            var thisVal = $(this).val().replace(' months', '')

            if (thisVal != $('#rental-term-value').val()) {
              $('#rental-term-value').val(thisVal).text(thisVal)
            }
          })
        })
        //this is for the collection pages
      } else {
        if (window.location.href.indexOf("collection") > -1) {
          var termMatch = termLength + ' months'
          $('.product_image_caption').each(function(){
            var $this = $(this)
            var variants = $this.find('.collection-variant')
            var flag = false
            variants.each(function(){
              if (flag == false) {
                if ( $(this).data('handle').replace(' months', '') == sessionStorage.getItem('rentalTerm') ) {
                  var newPrice = $(this).data('price') / 100
                  var months = $(this).data('handle')
                  var displayPrice = $(this).parent().parent().find('.price')
                  displayPrice.text( `$${newPrice} / Month` )
                  flag = true
                }
              }
            })
          })
        }
      }
    }
  }

  globalRentalTerm()

});



var waitForEl = function(selector, callback) {
  if (jQuery(selector).length) {
    callback();
  } else {
    setTimeout(function() {
      waitForEl(selector, callback);
    }, 100);
  }
};
